import { useRewardContext } from 'contexts/useRewardContext'
import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { LuClipboardCheck } from 'react-icons/lu'
import { createReward } from 'services/create-rewards'
import { getRateReward } from 'services/get-rate-reward'

export const Confirmation = () => {
  const { steps: employees, setCurrentStep } = useRewardContext()
  const [conversionRate, setConversionRate] = useState(0)
  const [totalValue, setTotalValue] = useState(0)

  useEffect(() => {
    const fetchConversionRate = async () => {
      try {
        const response = await getRateReward()
        setConversionRate(response.rate)
      } catch (error) {
        setConversionRate(0)
      }
    }

    fetchConversionRate()
  }, [])

  useEffect(() => {
    const calculatedTotalValue =
      employees.reduce((acc, employee) => {
        const rewardValue = Number(employee.reward) || 0
        return acc + rewardValue
      }, 0) * conversionRate

    setTotalValue(calculatedTotalValue)
  }, [employees, conversionRate])

  const handleOnclick = () => {
    toast
      .promise(createReward(employees), {
        loading: 'Salvando...',
        success: () => {
          localStorage.removeItem('selectedEmployees')
          return 'Recompensa criada com sucesso'
        },
        error: 'Erro ao criar recompensa',
      })
      .then(() => {
        setCurrentStep(0)
      })
      .catch((error) => {
        toast.error(error?.message ?? 'Erro ao criar recompensa')
      })
  }

  return (
    <section className="w-full h-full flex flex-col">
      <h1 className="text-xl leading-4 font-semibold">
        3. Estamos quase lá, cheque as informações abaixo
      </h1>

      <div className="flex border mt-10 p-6 gap-10 rounded-xl justify-center w-max mx-auto">
        <div className="">
          {employees.map((employee, index) => (
            <p key={index} className="leading-7 font-normal mt-4">
              {employee.newEmployee ? (
                <>
                  <strong>{employee.email}</strong> será adicionado em sua base
                  de Colaboradores, e receberá{' '}
                  <strong>
                    {Intl.NumberFormat('pt-BR', {
                      currency: 'BRL',
                    }).format(employee.reward)}{' '}
                    ViroCash
                  </strong>{' '}
                  de premiação.
                </>
              ) : (
                <>
                  <strong>{employee.email}</strong> receberá o equivalente{' '}
                  <strong>
                    à{' '}
                    {Intl.NumberFormat('pt-BR', {
                      currency: 'BRL',
                    }).format(employee.reward)}{' '}
                    ViroCash
                  </strong>{' '}
                  de premiação.
                </>
              )}
            </p>
          ))}

          <p className="leading-7 font-normal mt-4">
            Totalizando em {''}
            <strong>
              R$
              {Number(totalValue) === 0
                ? '0,00'
                : totalValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
            </strong>{' '}
            {''}
            que serão cobrados em seu próximo pagamento
          </p>
        </div>

        <div className="flex items-center justify-center h-full">
          <LuClipboardCheck size={'150px'} className="text-[#4F46E5]" />
        </div>
      </div>

      <div className="flex justify-center items-center gap-10 mt-10">
        <button
          onClick={() => setCurrentStep(1)}
          className="bg-gray-100 dark:bg-transparent shadow border-[1.5px] rounded-full px-5 py-3 font-medium hover:opacity-95"
        >
          Voltar
        </button>
        <button
          className="bg-[#4F46E5] text-white rounded-full px-5 py-3 hover:opacity-95"
          onClick={handleOnclick}
        >
          Confirmar
        </button>
      </div>
    </section>
  )
}
